import React from "react";
import { useSupportChat } from "shared-hooks";
import config from "config/global";

import { RouteComponentProps } from "react-router";

export default function withSupportChat<P extends RouteComponentProps<any>>(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<any>>
) {
  return function (props: P) {
    useSupportChat(props.location.pathname, undefined, config.supportChatBotId);

    return <WrappedComponent {...props} />;
  };
}
